import { useNavigate } from "react-router-dom";
import { Button, Typography } from "components/atoms";
import { CircularProgressBar } from "../CircularProgressBar";
import { useScreenSize } from "hooks";
import { decodeToken } from "utils/functions/decodeToken";
import { DASHBOARD_PROGRAME, SELF_PACED_PROGRAME } from "utils/constants";
import useGoogleAnalytics from "hooks/useGoogleAnalytics";
import { feature_toggle } from "featureToggle";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
  data?: any;
  widgetTrackingId?: string;
}

export const AIRecommendationSmallCard = ({ theme, data, widgetTrackingId }: IProps) => {
  const screen = useScreenSize();
  const navigate = useNavigate();

  const payload = decodeToken();

  const { trackEvent } = useGoogleAnalytics();

  const isDashboard =
    payload &&
    payload.hasOwnProperty("programtype") &&
    payload.programtype === DASHBOARD_PROGRAME;

  const isSelfPaced =
    payload &&
    payload.hasOwnProperty("programtype") &&
    payload.programtype === SELF_PACED_PROGRAME;

  const handleClick = () => {
    const topicName = data?.AssessmentObjective?.Parent?.Name;
    const subjectName = data?.AssessmentObjective?.Subject;
    
    const url = topicName && subjectName
      ? `/study-recommendations-tool?topic=${encodeURIComponent(topicName)}&subject=${encodeURIComponent(subjectName)}`
      : '/study-recommendations-tool';
    
    if(isDashboard) {
      navigate(url, { state: { data: data } });
      // track google tag manager event
      feature_toggle.googleTagManager.isEnable === true && trackEvent("button_click", "Start Topic")
    } else if (isSelfPaced) {
      navigate(url.replace(/^\//, ''), { state: { data: data } });
    }
  };

  return (
    <div className="circular-progress-bar-wrapper">
      <div className="title-section">
        <Typography
          label={
            data.AssessmentObjective.Parent.Name.length > 20
              ? data.AssessmentObjective.Parent.Name.substring(0, 20) + "..."
              : data.AssessmentObjective.Parent.Name
          }
          variant="h7Med"
          styles={screen.width > 424 ? "typography-custom-style" : ""}
        />
      </div>
      <div className="circular-progress-bar-section">
        <CircularProgressBar
          complete={0}
          inComplete={0}
          upComing={0}
          isAi={true}
          isThreeLayer={true}
          // customCircularStyle={true}
          aiPercentage={
            data ? Math.round((1 - data.IncorrectPercentage) * 100) : 0
          }
          theme={theme}
        />
      </div>
      <div className="description-section">
        <Typography
          label="Proficiency Level"
          variant="h7Book"
          styles="typography-custom-style"
        />
      </div>
      <div className="btn-section">
        <Button
          label="Start"
          type="score"
          icon={false}
          styles="btn-custom-style"
          onClick={handleClick}
          dataTrackingId={widgetTrackingId}
        />
      </div>
    </div>
  );
};
